import { memberType } from '../types/memberType'


const initialState = {
  loading: false,

  error: null
}

export const MemberReducer = (state = initialState, action) => {
  switch (action.type) {
    //get_employee_dependents

    case memberType.memberCoveredFail:
      return {
        ...state,
        error: action.payload,
        loading: false
      }
    default:
      return state
  }
}
